import { styled } from 'styled-components';
import { _useSelector, _useDispatch } from '@src/state/hooks';
import { setShowFullViewLoader } from '@src/state/slices/slice_app';
import { useEffect, useRef } from 'react';
import load from '@src/asset/img/load.png';

const Container = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  background-color: black;
  opacity: 0.5;
  z-index: 100;
`;

const Loader = styled.img`
  -khtml-user-select: none;
  -o-user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  animation: spin 3.3s linear infinite;
  opacity: 1;
  @keyframes spin {
    100% {
      transform: rotate(-360deg);
    }
  }
`;

export default function FullViewLoader() {
  const dispatch = _useDispatch();

  const showFullViewLoader = _useSelector(
    (state) => state.app.showFullViewLoader,
  );

  const activeTimerRef = useRef<number | null>(null);

  useEffect(() => {
    // if the loader is allowed to run for 30s, then we should stop it
    if (showFullViewLoader) {
      activeTimerRef.current = setTimeout(() => {
        dispatch(setShowFullViewLoader(false));
      }, 30000);
    } else {
      if (activeTimerRef.current) {
        clearTimeout(activeTimerRef.current);
        activeTimerRef.current = null;
      }
    }
  }, [showFullViewLoader]);

  if (!showFullViewLoader) return null;

  return (
    <Container>
      <Loader src={load} />
    </Container>
  );
}
